import CouponDoesNotApplyModal from './CouponDoesNotApplyModal';

export default CouponDoesNotApplyModal;
